import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ResourceGrid from './components/ResourceGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.beauty';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Mulebuy Spreadsheet Hub',
  url: SITE_URL,
  description:
    'Discover the most complete mulebuy spreadsheet platform online. Explore updated mulebuy spreadsheet lists, compare trusted agents, and access curated product spreadsheets for sneakers, fashion, gadgets, and budget finds.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="Ultimate Mulebuy Spreadsheet Hub 2026 — Verified Lists, Guides &amp; Deals"
        description="Discover the most complete mulebuy spreadsheet platform online. Explore updated mulebuy spreadsheet lists, compare trusted agents, and access curated product spreadsheets for sneakers, fashion, gadgets, and budget finds. Updated daily."
        canonicalPath="/"
        ogType="website"
        jsonLd={[websiteSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ResourceGrid />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}